import {Component, OnInit, ViewChild} from '@angular/core';
import {AgGridAngular} from 'ag-grid-angular';
import {CobrosAutoserviciosService} from '../../../services/cobrosAutoservicio/cobros-autoservicios.service';
import {moduloCobrosAutoservicio} from '../../../diccionarios/cobrosAutoServiciosModulo';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

@Component({
  selector: 'app-consulta-cobros-autoservicios',
  templateUrl: './consulta-cobros-autoservicios.component.html',
  styleUrls: ['./consulta-cobros-autoservicios.component.css']
})
export class ConsultaCobrosAutoserviciosComponent implements OnInit {

  @ViewChild('agGrid') agGrid: AgGridAngular;
  columnDefs: any[];
  rowData: any[];
  frameworkComponents: any;
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  textoBuscar: string;
  getRowNodeId: any;

  columnDefsAll: any[];
  rowDataAll: any[];
  rowSelectionAll: any;
  gridApiAll: any;
  gridColumnApiAll: any;
  textoBuscarAll: string;

  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  //mostrar campos
  mostrarGrid = true;
  //dataClienete
  dataCliente: any = {};
  textBoton = '';
  cobroAutoModulo: any = {};

  constructor(private cobrosAutoservicios: CobrosAutoserviciosService) {
    this.cobroAutoModulo = moduloCobrosAutoservicio;
    this.DAT_BTNS = this.cobroAutoModulo.button.buttonsNombre;
    this.DAT_MSG = this.cobroAutoModulo.mensajes;
    this.DAT_BTNCSS = this.cobroAutoModulo.button.buttonsCss;
    // this.DAT_BTNS = this.cobroAutoModulo.button;
    // this.DAT_MSG = this.cobroAutoModulo.mensajes;
    this.getAllCobros();
  }

  ngOnInit() {

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'N°lINEA',
        field: 'noLinea',
        // sortable: true,
        // filter: true,
        // checkboxSelection: true,
        // headerCheckboxSelection: true,
        width: 200
      },
      {
        headerName: 'TIPO',
        field: 'idTipoTrans',
        filter: true,
        width: 100,
      },
      {
        headerName: 'N° DOCUMENTO',
        field: 'noDocumento',
        filter: true,
        width: 200
      },
      {
        headerName: 'CLIENTE',
        field: 'idCliente',
        filter: true,
        width: 200
      },
      {
        headerName: 'NOMBRE',
        field: 'dscaCliente',
        filter: true,
        width: 250
      },
      {
        headerName: 'STATUS',
        field: 'status',
        filter: true,
        width: 200
      },
      {
        headerName: 'VALOR FACT ANT',
        field: 'valorFacturaAct',
        filter: true,
        width: 210
      },
      {
        headerName: 'VALOR COBRO',
        field: 'valorCobro',
        filter: true,
        width: 200
      },
      {
        headerName: 'VALOR FACT ACT',
        field: 'valorFacturaDesp',
        filter: true,
        width: 210
      },
      {
        headerName: 'VALOR ANTICIPO',
        field: 'valorAnticipo',
        filter: true,
        width: 200
      }
    ];
    this.rowSelection = 'multiple';
    this.getRowNodeId = function (data) {
      return data.noLinea;
    };

    this.columnDefsAll = [
      {
        // headerName: 'Ver',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.getAllCobrosDetalles.bind(this),
          label: this.DAT_BTNS.ver,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: 'Banco',
        field: 'idBanco',
        sortable: true,
        filter: true,
        // checkboxSelection: true,
        // headerCheckboxSelection: true,
        //width: 150
      },
      {
        headerName: 'Empresa',
        field: 'dscaEmpresa',
        filter: true,
        //width: 200
      },
      {
        headerName: 'Cliente',
        field: 'dscaCliente',
        filter: true,
        width: 250
      },
      {
        headerName: 'Via Pago',
        field: 'idViaPago',
        filter: true,
        width: 150
      },
      {
        headerName: 'N° Asiento Contable',
        field: 'noAsientoPago',
        filter: true,
        //width: 200
      },
      {
        headerName: 'N° Asiento Anticipo',
        field: 'noAsientoAnticipo',
        filter: true,
        //width: 200
      },
      {
        headerName: 'N° Referencia',
        field: 'referencia',
        filter: true,
        //width: 200
      }
    ];
    this.rowSelectionAll = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChangedAll() {
    this.gridApiAll.setQuickFilter(this.textoBuscarAll);
  }

  onGridReadyAll(params) {
    this.gridApiAll = params.api;
    this.gridColumnApiAll = params.columnApi;
  }

  getAllCobros() {
    this.cobrosAutoservicios.getAllCobros().subscribe((resp) => {
      console.log(resp);
      this.rowDataAll = resp;
    }, (err) => {
      this.rowData = [];
    });
  }

  getAllCobrosDetalles({rowData}) {
    let idCobroAutoserv = rowData.idCobroAutoserv;
    this.cobrosAutoservicios.getAllCobrosDetalles(idCobroAutoserv).subscribe((resp) => {
      console.log(resp);
      this.visualizarDetalle({cabecera: rowData, detalle: resp});
    });
  }

  visualizarDetalle(data) {
    this.mostrarGrid = false;
    this.dataCliente = data.cabecera;
    this.rowData = data.detalle;
  }

  regresarGrid() {
    this.mostrarGrid = true;
  }

  descargar() {
    this.descargarRecibo();
    this.descargarEstado();
  }

  descargarRecibo() {
    let idCobroAutoserv = this.dataCliente.idCobroAutoserv;
    this.cobrosAutoservicios.descargarReciboCobro(idCobroAutoserv).subscribe((resp) => {
      this.descargarArchivo(resp);
    });
  }

  descargarEstado() {
    let idCobroAutoserv = this.dataCliente.idCobroAutoserv;
    this.cobrosAutoservicios.descargarEstadoDocumentos(idCobroAutoserv).subscribe((resp) => {
      this.descargarArchivo(resp);
    });
  }

  descargarArchivo(respuesta) {
    let name_file = respuesta.name;
    let archivo = respuesta.content;
    const dataURI = "data:aplication/plain;base64," + (archivo);
    var a = document.createElement("a");
    a.href = dataURI;
    a.setAttribute("download", name_file);
    a.click();
  }

}
